import styled, { css } from "styled-components/macro";
import { device } from "../../device";

export const StyledDashboard = styled.div`
	padding: 0 24px;
	margin: auto;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: start;
	text-align: left;

	& ul {
		list-style: none;
	}
	@media ${device.tablet} {
		padding: 0;
	}

	@media ${device.desktop}{
		overflow-x: auto;
	}
`;

// segments dropdown
export const StyledChooseSegmentForm = styled.form`
	padding: 1rem 0;

	select {
		color: #3a5558;
		border: 1px solid #ebedee;
		border-radius: 8px;
		box-shadow: 0px 2px 2px 0px #0000000d;
		font-size: 14px;
		font-weight: 500;
		line-height: 21px;
		letter-spacing: 0em;
		text-align: left;
		padding: 0.8rem;
	}
`;

// notifications
export const StyledNotificationContainer = styled.div`
	width: 100%;
`;

export const StyledNotification = styled.div`
	position: relative;
	overflow: hidden;
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	padding: 1.2rem;
	width: 100%;
	border-radius: 8px;
	margin-bottom: 8px;
	text-align: left;
	${(props) =>
		props.type === "planUsage" &&
		css`
			background: #ffffff;
			border: 1px solid #ebedee;
			color: #575e68;
			padding: 24px 63px;
		`};
	${(props) =>
		props.type === "noStats" &&
		css`
			background: #ffffff;
			border: 1px solid #ebedee;
			color: #575e68;
			padding: 24px 63px;
		`};
	${(props) =>
		props.type === "gain" &&
		css`
			background: linear-gradient(110.71deg, #05345c -3.16%, #084e8a 107.12%), #cae5fc;
			color: #ffffff;
			padding: 24px 63px;
		`};
	${(props) =>
		props.type === "success" &&
		css`
			background: #f2f8f5;
			border: 1px solid #008060;
		`};
	${(props) =>
		props.type === "info" &&
		css`
			background: #ebf9fc;
			border: 1px solid #084e8a;
		`};
	${(props) =>
		props.type === "warning" &&
		css`
			background: #fff5ea;
			border: 1px solid #c05717;
		`};
`;
export const StyledNotificationInner = styled.div`
	width: 100%;
	margin: 0 16px;

	${(props) =>
		props.type === "gain" &&
		css`
			margin: 0;
			z-index: 2;
		`};

	h3 {
		font-weight: bold;
		font-size: 14px;
		line-height: 21px;
		opacity: 0.8;
		${(props) =>
			props.type === "gain" &&
			css`
				color: #ffffff;
				opacity: 1;
				font-weight: 600;
				font-size: 24px;
				line-height: 36px;
			`};
		${(props) =>
			props.type === "success" &&
			css`
				color: #008060;
			`};
		${(props) =>
			props.type === "info" &&
			css`
				color: #084e8a;
			`};
		${(props) =>
			props.type === "warning" &&
			css`
				color: #c05717;
			`};
	}
	p {
		margin: 4px 0;
		font-size: 14px;
		line-height: 21px;
		opacity: 0.8;
		${(props) =>
			props.type === "gain" &&
			css`
				color: #ffffff;
				opacity: 1;
				margin: 14px 0;
			`};
		${(props) =>
			props.type === "success" &&
			css`
				color: #008060;
			`};
		${(props) =>
			props.type === "info" &&
			css`
				color: #084e8a;
			`};
		${(props) =>
			props.type === "warning" &&
			css`
				color: #c05717;
			`};
	}
	button {
		&:hover {
			cursor: pointer;
		}
		padding: 4px 12px;
		border-radius: 4px;
		margin-top: 8px;
		font-weight: 600;
		font-size: 12px;
		line-height: 18px;
		color: #fcfcfd;
		${(props) =>
			props.type === "gain" &&
			css`
				background: none;
				border: none;
				font-weight: bold;
				font-size: 14px;
				line-height: 21px;
				padding: 0;
				margin-top: 0;
			`};
		${(props) =>
			props.type === "success" &&
			css`
				background: #008060;
				border: none;
			`};
		${(props) =>
			props.type === "info" &&
			css`
				background: #084e8a;
				border: none;
			`};
		${(props) =>
			props.type === "warning" &&
			css`
				background: #c05717;
				border: none;
			`};
	}
`;

export const StyledX = styled.span`
	&:hover {
		cursor: pointer;
	}
`;

export const StyledNoStats = styled.div`
	width: 100%;
	h3 {
		font-weight: 600;
		font-size: 24px;
		line-height: 36px;
		margin-bottom: 16px;
	}
	p {
		font-weight: normal;
		font-size: 16px;
		line-height: 20px;
		margin-bottom: 32px;
	}
`;

export const StyledProgressBar = styled.div`
	background: rgb(0, 128, 96, 0.2);
	border-radius: 4px;
	padding: 10px;
	margin-bottom: 10px;
	position: relative;
	overflow: hidden;
`;
export const StyledProgressBarFiller = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	padding: 10px 0;
	width: ${(props) => props.value}%;
	background: #008060;
`;
export const StyledProgressBarCaption = styled.div`
	display: flex;
	justify-content: space-between;
	font-size: 14px;
	line-height: 21px;
	color: #575e68;
`;
export const StyledGainSum = styled.div`
	padding: 24px;
	background: #ffffff;
	box-shadow: 0px 28px 32px -30px #074880;
	border-radius: 16px;
	color: #063761;
	text-align: center;
	z-index: 2;
	margin-left: 115px;

	h3 {
		font-weight: 600;
		font-size: 40px;
		line-height: 40px;
	}
	p {
		font-size: 14px;
		line-height: 21px;
		margin-top: 16px;
	}
`;

export const StyledPotentialGainBackground = styled.div`
	position: absolute;
	right: 0;
	top: 50%;
	transform: translate(0, -50%);
`;

// stats
export const StatsContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 0px;
	width: 100%;
`;
export const TimeOptions = styled.ul`
	list-style: none;
	display: flex;
	gap: 1rem;
	flex-direction: row;
	align-items: center;
	padding: 0px;
`;

export const TimeOptionsContainer = styled.div`
	margin-bottom: 24px;
	@media ${device.tablet} {
		width: 100%;
		margin-left: 0.5rem;
	}
`;

export const StyledTimeListItem = styled.li`
	&:hover {
		cursor: pointer;
		opacity: 1;
	}
	font-size: 14px;
	line-height: 21px;
	z-index: 1;

	${"" /* un-selected time */}
	font-weight: normal;
	color: #575e68;
	opacity: 0.5;
	border-bottom: transparent;

	${"" /* selected time */}
	${(props) =>
		props.selected &&
		css`
			font-weight: bold;
			color: #6270c6;
			opacity: 1;
			border-bottom: 3px solid #6270c6;
		`}
`;

export const StyledComment = styled.p`
	margin: 0;
	font-weight: normal;
	font-size: 12px;
	line-height: 18px;
	color: #6270c6;
	transition: 200ms ease;
	z-index: 0;
	margin-bottom: 0.5rem;
`;

export const StyledStats = styled.ul`
	width: 100%;

	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	padding: 0px;
	margin: 0;
	flex-wrap: wrap;
`;

export const StyledStatsCard = styled.li`
	min-width: 250px;
	flex-grow: 1;

	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 24px;

	background: #ffffff;
	border: 1px solid #ebedee;
	box-sizing: border-box;
	border-radius: 8px;
`;

export const CalcContainer = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;
export const StyledStatsCardTitle = styled.p`
	font-size: 16px;
	line-height: 100%;
	color: #111111;
	opacity: 0.8;
	margin-bottom: 24px;
`;
export const StyledSessionNum = styled.span`
	font-weight: 600;
	font-size: 40px;
	line-height: 40px;
	color: #111111;
`;
export const StyledSessionChange = styled.span`
	font-size: 16px;
	line-height: 100%;
	color: ${(props) => (props.green ? "#008060" : "#C64242")};
	display: flex;
	align-items: center;
`;
